<template>
  <div id="app">
    <notifications group="sitewide" />
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {

  },
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50 !important;
  height: 100%;
}

.nav-link {
  /* color: #656580 !important; */
  color: white !important
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show>.btn-primary.dropdown-toggle {
  background-color: #ff8f00 !important;
  border-color: #ff8f00 !important;
}

.page-item.active .page-link {
  background-color: #ff8f00 !important;
  border-color: #ff8f00 !important;
}

.page-link {
  position: relative;
  display: block;
  padding: .5rem .75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #ff8f00 !important;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.page-item.active .page-link {
  z-index: 1;
  color: #fff !important;
}

.page-link:hover {
  z-index: 2;
  color: #ff8f00 !important;
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
}</style>



// WEBPACK FOOTER //
// src/App.vue